import useDatasets from "datasets/hooks/useDatasets";
import { useFetcher } from "~/hooks/useFetcher";

const useConfiguredDatasets = () => {
  const { data: allDatasets, isLoading: loadingAllDatasets } = useDatasets();
  const { data: configuredDatasetIds, isLoading: loadingConfiguredIds } = useFetcher<string[]>(
    `/api/cohort-explorer/resources/datasets`
  );

  return {
    data: allDatasets?.filter(({ id }) => configuredDatasetIds?.includes(id)),
    isLoading: loadingAllDatasets || loadingConfiguredIds,
  };
};

export default useConfiguredDatasets;
